import { Form, FormInstance, Input, Modal, Select, Typography } from "antd";
import { useEffect, useState } from "react";
import { useGetSystemBank, useGetUserBank } from "../../../api/bank";
import { useCreateBankAccount } from "../../../api/bankAccount";
import Arrowdown from "../../../common/images/png/ArrowDown.png";
import { ReactComponent as CheckSelectIcon } from "../../../common/images/svg/CheckSelect.svg";
import { ReactComponent as CloseIcon } from "../../../common/images/svg/CloseIcon.svg";
import { ReactComponent as PlusGradientIcon } from "../../../common/images/svg/PlusGradient.svg";
import { ReactComponent as ArrowIcon } from "../../../common/images/svg/SuffixSelectIcon.svg";
import { ReactComponent as ClearIcon } from "../../../common/images/svg/XCircle.svg";
import { CustomButton } from "../../../components/button/buttonCustom";
import { ButtonOutlinedCustom } from "../../../components/button/buttonOulined";
import { useNotification } from "../../../components/providers/notification/useNotification";
import FormBankAddNew from "../../../pages/benificiary-remitter/management/modal-add-new/new-payee/form-bank-add-new";
import {
  accountNumberRules,
  branchNumberRules,
  clearFieldErrorMessageOnChange,
  onlyLatinCharsDigitsRule,
} from "../../../utils/form.constants";
import { useMetadataCountries } from "../../../utils/hooks/useMetadataCountries";
import { useMetadataCurrency } from "../../../utils/hooks/useMetadataCurrency";
import useResponsive from "../../../utils/hooks/useResponsive";

const { Option, OptGroup } = Select;

interface IFormBankProps {
  openAddBankAccount: boolean;
  setOpenAddBankAccount: React.Dispatch<React.SetStateAction<boolean>>;
  refectListBankAccount: any;
  beneficiarySelected: any;
  formSendMoney: FormInstance<any>;
  sendCurrency: number | undefined;
  dataAllCurrency: any;
}

const start = 0;
const end = 10;
const requiredFields = [
  "bankId",
  "accountNumber",
  "currencyCode",
  "branchNumber",
];

const requiredFieldsAddNew = [
  "accountNumber",
  "currencyCode",
  "branchNumber",
  "bankName",
  "bankSwift",
  "bankAddress",
  "bankCountry",
];

const FormBank = ({
  openAddBankAccount,
  setOpenAddBankAccount,
  refectListBankAccount,
  beneficiarySelected,
  formSendMoney,
  sendCurrency,
  dataAllCurrency,
}: IFormBankProps) => {
  const [form] = Form.useForm();
  const [searchCurrency, setSearchCurrency] = useState<string>("");
  const { isTablet } = useResponsive();
  const { open: openNotification } = useNotification();

  const { metadataCurrency } = useMetadataCurrency();
  const { metadataCountries } = useMetadataCountries();

  const [addNewBank, setAddNewBank] = useState(false);
  const [params, setParams] = useState({ start, end });
  const [paramSystem, setParamSystem] = useState({ start, end });
  const [searchBank, setSearchBank] = useState();
  const [bankSelected, setBankSelected] = useState<any>();
  const [isAllFieldsFilled, setIsAllFieldsFilled] = useState(true);

  // const bankId = Form.useWatch("bankId", form);
  // const accountNumber = Form.useWatch("accountNumber", form);
  // const currencyCode = Form.useWatch("currencyCode", form);
  // const abaRoutingNumber = Form.useWatch("abaRoutingNumber", form);
  // const bankStateBranchNumber = Form.useWatch("bankStateBranchNumber", form);
  // const branchNumber = Form.useWatch("branchNumber", form);
  // const bankName = Form.useWatch("bankName", form);
  // const bankSwift = Form.useWatch("bankSwift", form);
  // const bankAddress = Form.useWatch("bankAddress", form);
  // const bankCountry = Form.useWatch("bankCountry", form);

  const { data: metadataUserBank = { data: [] } } = useGetUserBank({
    start: params.start,
    end: params.end,
    name: searchBank,
  });

  const { data: metadataSystemBank = { data: [] } } = useGetSystemBank({
    start: paramSystem.start,
    end: paramSystem.end,
    name: searchBank,
  });

  const { mutate: createBankAccount, isLoading: isLoadingCreate } =
    useCreateBankAccount({
      onSuccess: (response: { data: { message: string; data: any } }) => {
        if (openNotification) {
          openNotification?.({
            key: "add_bank_account_success",
            message: response.data.message || "Add bank account successfully!",
            type: "success",
          });
        }
        refectListBankAccount();
        form.resetFields();
        setBankSelected(null);
        setOpenAddBankAccount(false);
        if (sendCurrency === response?.data?.data?.currencyId)
          formSendMoney.setFieldsValue({
            beneficiary_bank_account: response.data.data.id,
          });
      },
      onError: (error: { message: string }) => {
        if (openNotification) {
          openNotification({
            key: "add_bank_account_failure",
            message: error?.message || "Add bank account failed!",
            type: "error",
          });
        }
      },
    });

  const handleChangeCurrency = (value: string) => {
    setSearchCurrency(value);
  };

  const onSubmitBankAccount = (values: any) => {
    const bank = !values?.bankId
      ? {
        name: values?.bankName || "",
        swift: values?.bankSwift || "",
        legalAddress: values?.bankAddress || "",
        country: values?.bankCountry || "",
      }
      : undefined;

    const body = {
      ...(values?.bankId ? { bankId: values?.bankId } : { bank }),
      currencyCode: values?.currencyCode || "",
      abaRoutingNumber: values?.abaRoutingNumber !== '' && values?.abaRoutingNumber ? values?.abaRoutingNumber : undefined,
      bankStateBranchNumber: values?.bankStateBranchNumber !== '' && values?.bankStateBranchNumber ? values?.bankStateBranchNumber : undefined,
      branchNumber: values?.branchNumber || "",
      accountNumber: values?.accountNumber || "",
      companyId: Number(beneficiarySelected?.id),
    };
    createBankAccount(body as any);
  };

  // useEffect(() => {
  //   const fields = addNewBank ? requiredFieldsAddNew : requiredFields;
  //   const values = form.getFieldsValue(fields);
  //   const allFilled = fields.every((field) => !!values[field]);
  //   setIsAllFieldsFilled(allFilled);
  // }, [
  //   addNewBank,
  //   bankId,
  //   accountNumber,
  //   currencyCode,
  //   abaRoutingNumber,
  //   bankStateBranchNumber,
  //   branchNumber,
  //   bankName,
  //   bankSwift,
  //   bankAddress,
  //   bankCountry,
  // ]);

  const handleCancel = () => {
    if (isLoadingCreate) return;
    setOpenAddBankAccount(false);
    form.resetFields();
    setBankSelected(null);
  };

  const getCurrencyCode = (currencyId: number | undefined): string => {
    if (!currencyId) return "";
    const currency = dataAllCurrency.find((item: any) => item.id === currencyId);
    return currency?.symbol;
  }

  useEffect(() => {
    if (!sendCurrency || !sendCurrency) return;
    const currencyCode = getCurrencyCode(sendCurrency);
    form?.setFieldValue("currencyCode", currencyCode);
  }, [sendCurrency, sendCurrency]);

  return (
    <Modal
      open={!!openAddBankAccount}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
      maskClosable={false}
      title={
        <>
          <Typography
            style={{
              fontSize: isTablet ? 16 : 20,
              fontWeight: 700,
              color: "#C2C6CE",
            }}
          >
            Add Bank Account
          </Typography>
          <CloseIcon onClick={handleCancel} className="icon-animation" />
        </>
      }
      className="edit-wallet-modal"
    >
      <Form
        form={form}
        onFinish={onSubmitBankAccount}
        onValuesChange={clearFieldErrorMessageOnChange(form)}
        initialValues={{
          currencyCode: getCurrencyCode(sendCurrency),
        }}
      >
        <div className="form-edit-wallet-content">
          <div className="bank-detail">
            <div className="bank-detail-header">
              <Typography.Text style={{ lineHeight: "32px" }} className="title">
                Bank Details
              </Typography.Text>
              {addNewBank ? (
                <ButtonOutlinedCustom
                  text={"Cancel"}
                  size="small"
                  width={79}
                  onClick={() => setAddNewBank(false)}
                />
              ) : null}
            </div>
            {addNewBank ? (
              <FormBankAddNew metadataCountries={metadataCountries} />
            ) : (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    gap: 16,
                  }}
                >
                  <Form.Item
                    label="Bank"
                    name="bankId"
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                    validateTrigger="onBlur"
                    className="select-bank-detail"
                  >
                    <Select
                      allowClear
                      clearIcon={
                        <ClearIcon style={{ height: 12, width: 12 }} />
                      }
                      className="beneficiary-bank-account"
                      placeholder="Choose a bank"
                      suffixIcon={bankSelected ? null : <ArrowIcon />}
                      popupClassName="custom-select-bank"
                      showSearch
                      onChange={(id) => {
                        const selected = [
                          ...metadataSystemBank.data,
                          ...metadataUserBank.data,
                        ].find((item: any) => item.id === id);
                        setBankSelected(selected);
                      }}
                      onSearch={(value: any) => {
                        setSearchBank(value);
                        setParams({ start: 0, end: 10 });
                        setParamSystem({ start: 0, end: 10 });
                      }}
                      filterOption={() => true}
                    >
                      <OptGroup label="User Bank">
                        {Array.isArray(metadataUserBank.data) &&
                          metadataUserBank.data.map((item: any) => (
                            <Option key={item.id} value={item.id}>
                              <span
                                className="ant-select-custom-value "
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {item.name}
                              </span>
                              {bankSelected?.id === item.id && (
                                <CheckSelectIcon />
                              )}
                            </Option>
                          ))}
                        {metadataUserBank.data.length === params.end && (
                          <Option key="load-more" disabled>
                            <span
                              style={{
                                fontSize: isTablet ? 12 : 14,
                                color: "rgba(29, 171, 241, 1)",
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setParams((prev) => ({
                                  ...prev,
                                  end: prev.end + 10,
                                }));
                              }}
                            >
                              Load more <img src={Arrowdown} />
                            </span>
                          </Option>
                        )}
                      </OptGroup>
                      <div className="hr-bank-selected" />
                      <OptGroup label="System Banks">
                        {Array.isArray(metadataSystemBank.data) &&
                          metadataSystemBank.data.map((item: any) => (
                            <Option key={item.id} value={item.id}>
                              <span
                                className="ant-select-custom-value "
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {item.name}
                              </span>
                              {bankSelected?.id === item.id && (
                                <CheckSelectIcon />
                              )}
                            </Option>
                          ))}
                        {metadataSystemBank.data.length === paramSystem.end && (
                          <Option key="load-more" disabled>
                            <span
                              style={{
                                fontSize: isTablet ? 12 : 14,
                                color: "rgba(29, 171, 241, 1)",
                                fontWeight: 600,
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                setParamSystem((prev) => ({
                                  ...prev,
                                  end: prev.end + 10,
                                }));
                              }}
                            >
                              Load more <img src={Arrowdown} />
                            </span>
                          </Option>
                        )}
                      </OptGroup>
                    </Select>
                  </Form.Item>
                  <div
                    className="button-add-new-bank"
                    onClick={() => setAddNewBank(true)}
                  >
                    <PlusGradientIcon />
                  </div>
                </div>
                {bankSelected ? (
                  <>
                    <Typography.Text
                      style={{
                        color: "#ffffff",
                        fontSize: isTablet ? 12 : 14,
                        fontWeight: 400,
                      }}
                    >{`Name: ${bankSelected?.name || ""}`}</Typography.Text>
                    <Typography.Text
                      style={{
                        color: "#ffffff",
                        fontSize: isTablet ? 12 : 14,
                        fontWeight: 400,
                      }}
                    >{`Swift: ${bankSelected?.swift || ""}`}</Typography.Text>
                    <Typography.Text
                      style={{
                        color: "#ffffff",
                        fontSize: isTablet ? 12 : 14,
                        fontWeight: 400,
                      }}
                    >{`Address: ${bankSelected?.legalAddress || ""
                      }`}</Typography.Text>
                  </>
                ) : null}
              </div>
            )}
          </div>
          <div className="account-detail">
            <Typography.Text className="title">Account Details</Typography.Text>
            <Form.Item
              label="Account No or IBAN"
              name="accountNumber"
              validateTrigger="onBlur"
              rules={accountNumberRules}
            >
              <Input placeholder="Enter account number or IBAN" />
            </Form.Item>
            <Form.Item
              label="Currency"
              name="currencyCode"
              validateTrigger="onBlur"
              rules={[{ required: true, message: "This field is required" }]}
            >
              <Select
                disabled
                placeholder="Select the account currency"
                className="select-country-beneficiary"
                suffixIcon={<ArrowIcon />}
                onChange={handleChangeCurrency}
                optionLabelProp="label"
              >
                {metadataCurrency.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        gap: 2,
                      }}
                    >
                      <span
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          flex: 1,
                        }}
                      >
                        {item.label}
                      </span>
                      {searchCurrency === item.value && (
                        <CheckSelectIcon style={{ flexShrink: 0 }} />
                      )}
                    </span>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="ABA Routing Number"
              name="abaRoutingNumber"
              validateTrigger="onBlur"
              rules={[
                {
                  max: 25,
                  message: "Maximum 25 characters",
                  validateTrigger: "onBlur",
                },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    const trimmed = value.trim();
                    if (trimmed.length < 4) {
                      return Promise.reject(new Error("Minimum 4 characters"));
                    }

                    return Promise.resolve();
                  },
                },
                onlyLatinCharsDigitsRule,
              ]}
            >
              <Input
                placeholder="Enter the ABA routing number"
                onKeyDown={(e) => {
                  const target = e.currentTarget as HTMLInputElement;
                  if (e.key === " " && target.selectionStart === 0) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <Typography.Text
              style={{
                color: '#F28A28',
                fontSize: isTablet ? 10 : 12,
                fontWeight: 400,
                lineHeight: '16px',
                marginTop: '-16px',
              }}>
              {
                'If not available, please key in 000000.'
              }
            </Typography.Text>
            <Form.Item
              label="Bank State Branch Number"
              name="bankStateBranchNumber"
              validateTrigger="onBlur"
              rules={[
                {
                  max: 25,
                  message: "Maximum 25 characters",
                  validateTrigger: "onBlur",
                },
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    const trimmed = value.trim();
                    if (trimmed.length < 4) {
                      return Promise.reject(new Error("Minimum 4 characters"));
                    }

                    return Promise.resolve();
                  },
                },
                onlyLatinCharsDigitsRule,
              ]}
            >
              <Input
                placeholder="Enter the BSB number"
                onKeyDown={(e) => {
                  const target = e.currentTarget as HTMLInputElement;
                  if (e.key === " " && target.selectionStart === 0) {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
            <Typography.Text
              style={{
                color: '#F28A28',
                fontSize: isTablet ? 10 : 12,
                fontWeight: 400,
                lineHeight: '16px',
                marginTop: '-16px',
              }}>
              {
                'If not available, please key in 000000.'
              }
            </Typography.Text>
            <Form.Item
              label="Branch Number"
              name="branchNumber"
              validateTrigger="onBlur"
              rules={branchNumberRules}
            >
              <Input placeholder="Enter the branch number" />
            </Form.Item>
            <Typography.Text
              style={{
                color: '#F28A28',
                fontSize: isTablet ? 10 : 12,
                fontWeight: 400,
                lineHeight: '16px',
                marginTop: '-16px',
              }}>
              {
                'If not available, please key in 000000.'
              }
            </Typography.Text>
          </div>
        </div>
        <div className="form-edit-wallet-footer">
          <ButtonOutlinedCustom
            text={"Cancel"}
            size={isTablet ? "medium" : "large"}
            width={"50%"}
            onClick={handleCancel}
            isLoading={isLoadingCreate}
          />
          <CustomButton
            type="submit"
            text={"Save"}
            size={isTablet ? "medium" : "large"}
            width={"50%"}
            isLoading={isLoadingCreate}
            disabled={!isAllFieldsFilled}
          />
        </div>
      </Form>
    </Modal>
  );
};

export default FormBank;
